import { render, staticRenderFns } from "./DashboardDetail.vue?vue&type=template&id=31f33190&"
import script from "./DashboardDetail.vue?vue&type=script&lang=js&"
export * from "./DashboardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports